import React, { useState } from 'react'
import { createPortal } from 'react-dom'

import { SessionDataContextProvider } from '../misc/session_context'

import { sortRatingScales } from '../misc/rating_scales'
import SaleListings from './sale_listings'

export default function SaleProductShow(props) {
  const { node } = props.queryResponse.data.products.edges[0]
  const [selectedListingId, setListingId] = useState(node.saleProduct?.saleListings[0]?.id)

  // ----------------------------------------
  // DOM
  // ----------------------------------------

  return (
    <SessionDataContextProvider>
      <div>
        <SaleProductRender product={node} selectedListingId={selectedListingId} setListingSelection={setListingId} />
      </div>
    </SessionDataContextProvider>
  )
}

function SaleProductRender({ product: { saleProduct, fullName }, product, selectedListingId, setListingSelection }) {
  if (saleProduct === null) {
    // If there isn't a SaleProduct... then we don't sell this currently
    return (
      <div>
        <h1>{fullName}</h1>
        <h4>This product is currently not for sale, please check back later</h4>
      </div>
    )
  } else {
    if (saleProduct.saleListings.length > 0) {
      // This is the happy path!
      return <SaleProduct { ...{ product, selectedListingId, setListingSelection } } />
    } else {
      // When we have SaleProduct but there are no listings we're just out of stock
      return (
        <div>
          <h1>{fullName}</h1>
          <h4>This product is currently out of stock, please check back later</h4>
        </div>
      )
    }
  }
}

function SaleProduct({ product: { saleProduct: { saleListings, ratingScales }, saleProduct }, selectedListingId, setListingSelection }) {
  const sortedRatingScales = sortRatingScales(ratingScales)

  function createIncludesPortal(saleProduct) {
    const mount = document.getElementById('sale_product_includes_react_portal')
    if (!mount) return

    const includes = (
      <div className='right-box'>
        <div className='includes box'>
          <h2 className='subhead no-border'>Includes</h2>
          <ul>
            {saleProduct.items.map(item => <li key={item.id}>{item.publicName || item.fullName}</li>)}
          </ul>
        </div>
      </div>
    )

    return createPortal(includes, mount)
  }

  return (
    <div>
      <hr />

      <SaleListings
        sortedRatingScales={sortedRatingScales}
        saleListings={saleListings}
        onChangeListing={setListingSelection}
        selectedListingId={selectedListingId}
      />

      {createIncludesPortal(saleProduct)}
    </div>
  )
}
